import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const empty = { nome: '', estado: '' };

export default function AdminCidades() {
  const [cidades, setCidades] = useState([]);
  const [form, setForm] = useState(empty);
  const [editando, setEditando] = useState(null);
  const [msg, setMsg] = useState('');

  useEffect(() => { carregar(); }, []);
  function carregar() { api.get('/cidades/todas').then(setCidades).catch(() => {}); }

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      if (editando) { await api.put(`/cidades/${editando.id}`, { ...form, ativo: editando.ativo }); }
      else { await api.post('/cidades', form); }
      setMsg('Salvo com sucesso!'); setForm(empty); setEditando(null); carregar();
    } catch (err) { setMsg(err.message); }
  }

  async function deletar(id) {
    if (!window.confirm('Remover esta cidade?')) return;
    await api.delete(`/cidades/${id}`); carregar();
  }

  return (
    <div>
      <h2 className="admin-title">Cidades</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      <form onSubmit={salvar} className="admin-form">
        <h3>{editando ? 'Editar Cidade' : 'Nova Cidade'}</h3>
        <div className="form-row">
          <div className="form-group"><label>Nome</label><input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required /></div>
          <div className="form-group"><label>Estado (UF)</label><input value={form.estado} onChange={e => setForm({ ...form, estado: e.target.value })} maxLength={2} required /></div>
        </div>
        <div className="admin-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          {editando && <button type="button" className="btn btn-secondary" onClick={() => { setEditando(null); setForm(empty); }}>Cancelar</button>}
        </div>
      </form>
      <div className="admin-table-wrap">
        <table>
          <thead><tr><th>Nome</th><th>Estado</th><th>Ativo</th><th>Ações</th></tr></thead>
          <tbody>
            {cidades.map(c => (
              <tr key={c.id}>
                <td>{c.nome}</td><td>{c.estado}</td>
                <td>{c.ativo ? <span className="badge badge-success">Sim</span> : <span className="badge badge-danger">Não</span>}</td>
                <td>
                  <div className="admin-actions">
                    <button className="btn btn-secondary" onClick={() => { setEditando(c); setForm({ nome: c.nome, estado: c.estado }); }}>Editar</button>
                    <button className="btn btn-danger" onClick={() => deletar(c.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
